import { Instance } from 'mobx-state-tree';
import { ReversiblePlanningActionsDtoModelBase } from './ReversiblePlanningActionsDtoModel.base';

/* The TypeScript type of an instance of ReversiblePlanningActionsDtoModel */
export interface ReversiblePlanningActionsDtoModelType extends Instance<typeof ReversiblePlanningActionsDtoModel.Type> {}

/* A graphql query fragment builders for ReversiblePlanningActionsDtoModel */
export {
  selectFromReversiblePlanningActionsDto,
  reversiblePlanningActionsDtoModelPrimitives,
  ReversiblePlanningActionsDtoModelSelector,
} from './ReversiblePlanningActionsDtoModel.base';

/**
 * ReversiblePlanningActionsDtoModel
 */
export const ReversiblePlanningActionsDtoModel = ReversiblePlanningActionsDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
